<template>
  <div
    v-if="newDeliveryDate && getDate"
    class="select-date-presentation"
  >
    <div class="select-date-presentation__title">
      Дата доставки
    </div>
    <div class="select-date-presentation__right-content">
      {{ getDate }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectDatePresentation',

  props: {
    newDeliveryDate: {
      type: Object,
      default () {
        return null
      },
    },
  },

  computed: {
    getDate () {
      const {
        date = null,
      } = this.newDeliveryDate

      return this.$date(date).format('D MMMM, dd')
    },
  },
}
</script>

<style lang="scss">
$prefix: 'select-date-presentation';

.#{$prefix} {
  @include row;
  align-items: center;
}

.#{$prefix}__title {
  @include typography('h1', 'bold');
}

.#{$prefix}__right-content {
  @include typography('b2', 'bold');
  color: map-get($colors, 'default');

  margin-left: auto;
}
</style>
